// extracted by css-extract-rspack-plugin
export default {"reasonCount":"reasonCount-FzRszp","overLimit":"overLimit-nIsLaj"};// extracted by css-extract-rspack-plugin
export default {"reasonCount":"reasonCount-FzRszp","overLimit":"overLimit-nIsLaj"};